<template>
    <button :style="style" @click="handleClick" class="button button-outline">
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: 'LoginButton',
    props: {
        mobile: Boolean
    },
    computed: {
        color() {
            return this.$store.getters.COLOR
        },
        style() {
            if(this.mobile) return {color: '#000', borderColor: '#000'}
            else return {color: this.color.secondary, borderColor: this.color.secondary}
        }
    },
    methods: {
        handleClick(evt) {
            this.$emit('click', evt);
        }
    }
}
</script>
:style="[$bgColor(color.primary), { color: color.secondary }]" 
<style scoped>
.button {
    width: 113px;
    display: inline-block;
    box-sizing: border-box;
    padding: .5em 1em;
    border: 2px solid;
    border-radius: 10px;
    color: white;
    border-color: white;
    text-decoration: none;
    font-family: inherit;
    font-size: inherit;
    font-weight: 600;
    line-height: 1.3;
    font-size: .85rem;
    transition: opacity .2s;
}

.button-outline {
    background-color: transparent;
}
</style>
